import React from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';

const AddPropertyPage: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Box py={4}>
        <Typography variant="h4" component="h1" gutterBottom>
          Add New Property
        </Typography>
        <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
          <Typography variant="body1">
            Property submission form will be implemented here.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default AddPropertyPage;